import { addSlashes } from "../route.utils";

export enum STANDALONE_PATH_SEGMENTS {
  QR_UPLOAD = "qr-upload",
  CREATE_COMPANY = "create-company",
  CREATING_COMPANY = "creating-company",
  SUBSCRIPTION_TOKENS = "top-up-tokens",
  SUBSCRIPTION_PLAN = "subscription-plan",
  SUBSCRIPTION_EXPIRED = "subscription-expired",
  STRIPE_PAYMENT = "stripe-payment",
  E_SIGN = "documents/sign",
  CERTIFICATE = "documents/certificate/:sigId",
  CERTIFICATE_COMBINED = "documents/certificate-combined",
  NFC_LANDING = "nfc/:token",
  NFC_ACTION = "nfc-action/:token",
  DIGITAL_ID_PUBLIC = "business-card/:id",
  EVENT_RSVP = "events/rsvp/:token",
  CONNECTION_LOST = "connection-lost",
}

export const STANDALONE_PATHS = Object.freeze({
  QR_UPLOAD: addSlashes(STANDALONE_PATH_SEGMENTS.QR_UPLOAD),
  CREATE_COMPANY: addSlashes(STANDALONE_PATH_SEGMENTS.CREATE_COMPANY),
  CREATING_COMPANY: addSlashes(STANDALONE_PATH_SEGMENTS.CREATING_COMPANY),
  SUBSCRIPTION_TOKENS: addSlashes(STANDALONE_PATH_SEGMENTS.SUBSCRIPTION_TOKENS),
  SUBSCRIPTION_PLAN: addSlashes(STANDALONE_PATH_SEGMENTS.SUBSCRIPTION_PLAN),
  SUBSCRIPTION_EXPIRED: addSlashes(
    STANDALONE_PATH_SEGMENTS.SUBSCRIPTION_EXPIRED,
  ),
  STRIPE_PAYMENT: addSlashes(STANDALONE_PATH_SEGMENTS.STRIPE_PAYMENT),
  E_SIGN: addSlashes(STANDALONE_PATH_SEGMENTS.E_SIGN),
  CERTIFICATE: (sigId: number | string) => `/documents/certificate/${sigId}`,
  CERTIFICATE_COMBINED: (sigIds: Array<number | string>) =>
    `/documents/certificate-combined?ids=${sigIds.join(",")}`,
  NFC_LANDING: (token: string) => `/nfc/${token}`,
  NFC_ACTION: (token: string) => `/nfc-action/${token}`,
  DIGITAL_ID_PUBLIC: (id: number | string) => `/business-card/${id}`,
  EVENT_RSVP: (token: string) => `/events/rsvp/${token}`,
  CONNECTION_LOST: addSlashes(STANDALONE_PATH_SEGMENTS.CONNECTION_LOST),
});
